<template>
    <div>
        <v-card v-if="isRunningAsInstalled" color="accent">
            <v-card-title>
                <h3 class="title">Je bent helemaal PWA ready</h3>
            </v-card-title>
            <v-card-text>
                Je bekijkt deze app nu als 'Progressive Web App'!
                Er is nu een icoon op je apparaat geplaatst met de naam
                'Inspiratietuin' waarmee je de PWA ook kunt starten.
            </v-card-text>
        </v-card>
        <v-card v-else-if="isInstalled" color="accent">
            <v-card-title>
                <h3 class="title">Bedankt</h3>
            </v-card-title>
            <v-card-text>
                Bedankt voor het installeren van deze 'Progressive Web App'.
                Er is nu een icoon op je apparaat geplaatst met de naam
                'Inspiratietuin' waarmee je de PWA ook kunt starten.
            </v-card-text>
        </v-card>
        <v-card v-else-if="isInstallable" :elevation="12" color="accent">
            <v-card-title>
                <h3 class="title">Installeer deze app</h3>
            </v-card-title>
            <v-card-text>
                Hoi! We zien dat je deze 'Progressive Web App' nog niet geïnstalleerd hebt.<br />
                Je kunt dat wel heel gemakkelijk doen door op onderstaande knop te drukken!
            </v-card-text>
            <v-card-actions>
                <v-btn class="ml-0 mb-4" @click="installPWA" block>
                    <v-icon class="mr-2">get_app</v-icon>
                    Installeer deze app
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-else>
            <v-card-text>
                Deze Progressive Web App kun je helaas nog niet met
                een druk op de knop installeren vanuit de app zelf.
                Dit is een beperking van je huidige browser.<br/>
                In sommige browsers komt er vanzelf een popup in beeld met de vraag om te installeren.
                Bij andere browsers kun je op een knopje drukken in de adresbalk.
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    data () {
        return {
            deferredInstallPrompt: null,
            isInstalled: false,
            isRunningAsInstalled: false,
        }
    },
    computed: {
        isInstallable () {
            return !this.isRunningAsInstalled && this.deferredInstallPrompt
        },
    },
    methods: {
        async installPWA () {
            if (!this.deferredInstallPrompt) {
                return
            }

            this.deferredInstallPrompt.prompt()

            const choiceResult = await this.deferredInstallPrompt.userChoice
            if (choiceResult.outcome === 'accepted') {
                this.deferredInstallPrompt = null
            }
        },
        beforeInstallPromptHandler (e) {
            this.deferredInstallPrompt = e
            e.preventDefault()
        },
        appInstalledHandler (e) {
            window.localStorage.setItem('appinstalled', true)
            this.isInstalled = true
        },
        async updateInstallStatus () {
            if (window.localStorage.getItem('appinstalled')) {
                this.isInstalled = true
            }

            // give some time to initialize
            await this.$nextTick()
            await new Promise((resolve) => setTimeout(resolve, 100))
            this.isRunningAsInstalled = !!window.matchMedia('(display-mode: standalone)').matches
        },
    },
    mounted () {
        window.addEventListener('beforeinstallprompt', this.beforeInstallPromptHandler)
        window.addEventListener('appinstalled', this.appInstalledHandler)
        this.updateInstallStatus()
    },
    beforeDestroy () {
        window.removeEventListener('beforeinstallprompt', this.beforeInstallPromptHandler)
        window.removeEventListener('appinstalled', this.appInstalledHandler)
    },
}
</script>
